import { render, staticRenderFns } from "./SignupToolbar.vue?vue&type=template&id=71c0ec78&scoped=true"
import script from "./SignupToolbar.vue?vue&type=script&lang=js"
export * from "./SignupToolbar.vue?vue&type=script&lang=js"
import style0 from "./SignupToolbar.vue?vue&type=style&index=0&id=71c0ec78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0ec78",
  null
  
)

export default component.exports